import { useHistory } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { GRAPHIC_LIST_CREATE, GRAPHIC_LIST_UPDATE } from 'graphql/mutation/graphic-packing-gql';
import { successNotification, errorNotification } from "components/request-result";
import GraphicPackingConst from '../graphic-packing-const';
import GraphicStandConst from 'components/graphic-stand/graphic-stand-const';


const useMutationGraphicPackingCreateUpdate = (id) => {
    const history = useHistory();
    const [ mutateCreate, { loading: loadingCreate } ] = useMutation(GRAPHIC_LIST_CREATE, {
        update(cache, { data }) {
            const { graphicListCreate: { label, message, graphicList } } = data;

            // Redirect to stands page with the created graphic packing ID
            history.push(`${ GraphicPackingConst.basePath }/${ graphicList.id }${ GraphicStandConst.basePath }`);

            successNotification({
                title: label,
                description: message
            });
        },
        onError(error) {
            errorNotification(error);
        }
    });

    const [ mutateUpdate, { loading: loadingUpdate } ] = useMutation(GRAPHIC_LIST_UPDATE, {
        update(cache, { data }) {
            const { graphicListUpdate: { label, message, graphicList } } = data;

            // Redirect to stands page with the updated graphic packing ID
            history.push(`${ GraphicPackingConst.basePath }/${ graphicList.id }${ GraphicStandConst.basePath }`);

            successNotification({
                title: label,
                description: message
            });
        },
        onError(error) {
            errorNotification(error);
        }
    });

    return {
        _setGraphicPackingCreateUpdate: async ({ variables }) => {
            const { input } = variables;
            const { id } = input || {};

            try
            {
                let result;

                if (id)
                {
                    result = await mutateUpdate({
                        variables
                    });
                } else
                {
                    result = await mutateCreate({
                        variables
                    });
                }

                return result;
            } catch (e)
            {
                console.error(e);
            }
        },
        loadingGraphicPackingCreateUpdate: loadingCreate || loadingUpdate
    };
};

export default useMutationGraphicPackingCreateUpdate;